// extracted by mini-css-extract-plugin
export default {"landingPageBannerBlock":"LandingPageBannerBlock_landingPageBannerBlock__WtanO","landingPageBanner":"LandingPageBannerBlock_landingPageBanner__SSpsj"};